import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {listDesigns} from '../utils/utilsDesign';

import * as PD from '../classes/pdStyle';

class ListDesigns extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            Designs : null
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
        return;
    }

    loadData(){
        const onLoad = (data) => {
            this.setState({
                isLoaded: true,
                Designs: data
            });

            if (this.state.onLoad){
                this.state.onLoad(data.length);
            }
        }
      
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoaded: false
            });
        }

        listDesigns(this.dsd, this.state.filters, onLoad, onFail);
    }

    setup(){
        let StateChange = {
            filters: {},
            data: null,
            columns: {
                owner: true,
                status: true
            },
            load: false,
            onLoad: null
        }

        if (getParam('filters', this.props)){
            StateChange.filters = getParam('filters', this.props);
        }

        if (getParam('columns', this.props)){
            StateChange.columns = getParam('columns', this.props);
        }

        if (getParam('onLoad', this.props)){
            StateChange.onLoad = getParam('onLoad', this.props);
        }

        this.setState(StateChange, () => {
            this.loadData();
        });

    }

    included(Design) {
        let IncludeThis = true;
        return IncludeThis;
    }

    render() {
        if (this.state.isFailed) {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }

        if (this.state.isLoaded) {
            let arrDesigns = this.state.Designs;
            if (isArray(arrDesigns)){
                if (arrDesigns.length > 0){
                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.status &&
                                        <PD.Th>Status</PD.Th>                            
                                    }
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>
                            {
                                arrDesigns.map(
                                    (Design, pos) => 
                                    {
                                        if (this.included(Design)) {
                                            return (
                                                <PD.Tr key={pos}>
                                                    <PD.Td>
                                                        <PD.PdNavLink to={"/design/" + Design.id}>{Design.name}</PD.PdNavLink>
                                                    </PD.Td>
                                                    {this.state.columns.owner &&
                                                        <PD.Td>
                                                            {Design.Owner &&
                                                                Design.Owner.organisation}
                                                        </PD.Td>
                                                    }
                                                    {this.state.columns.status &&
                                                        <PD.Td>
                                                            {Design.status}
                                                        </PD.Td>
                                                    }                                                        
                                                    <PD.Td>
                                                        <PD.MdPresent>{truncate(Design.description, 400)}</PD.MdPresent>
                                                    </PD.Td>
                                                </PD.Tr>
                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>
                        </PD.Table>
                    )
                }
            }
        }

        return <div />;
    };    
};
        
// Wrap and export
export default function ListDesigns_wrapper(props) {
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListDesigns {...props} navigation={navigation} location={location} params={params} />;
}
